/** 管理后台与用户 H5 分开标记，来源信息只参与追踪。 */
export function clientEnvironmentHeaders(
  browser = typeof navigator === 'undefined' ? undefined : navigator,
  clientType: 'admin_web' | 'h5' = 'admin_web',
): Record<string, string> {
  const ua = browser?.userAgent.toLowerCase() ?? '';
  const ios =
    /iphone|ipad|ipod/.test(ua) ||
    (/macintosh/.test(ua) && (browser?.maxTouchPoints ?? 0) > 1);
  const os = /harmony|openharmony/.test(ua)
    ? 'harmonyos'
    : ios
      ? 'ios'
      : /android/.test(ua)
        ? 'android'
        : /windows|win32|win64/.test(ua)
          ? 'windows'
          : /macintosh|mac os|macos/.test(ua)
            ? 'macos'
            : /linux/.test(ua)
              ? 'linux'
              : 'unknown';
  return {
    'X-Client-Type': clientType,
    'X-Client-Environment': /micromessenger|wxwork/.test(ua)
      ? 'wechat_browser'
      : 'browser',
    'X-Client-OS': os,
    'X-Client-Device':
      /ipad|tablet/.test(ua) || (ios && /macintosh/.test(ua))
        ? 'tablet'
        : ['ios', 'android', 'harmonyos'].includes(os)
          ? 'phone'
          : ['macos', 'windows', 'linux'].includes(os)
            ? 'pc'
            : 'unknown',
  };
}
